/**
 * @file 共通IndexedDBマスタ参照モジュール
 * @namespace ddv2.library
 */

/**
 * @module indexeddb
 */
export default {
  /**
   * IDから情報を取得する
   * @param {*} list データリスト
   * @param {*} id ID
   * @returns
   */
  getRecord: function (list, id) {
    var d = list.find((t) => {
      return t.id === id
    })
    return d
  },
  /**
   * Cdから情報を取得する
   * @param {*} list データリスト
   * @param {*} targetCdNm 対象コードカラム名
   * @param {*} cd コード値
   * @param {*} date 基準日
   * @returns
   * @example indexeddb.getRecordByCd('0010', this.eigyoshoList, 'eigyoshoCd', '99', '2022/07/30')
   */
  getRecordByCd: function (kaishaCd, list, targetCdNm, cd, date) {
    var d = list.find((t) => {
      if (t.tekiyoStartYmdString !== undefined) return t.kaishaCd === kaishaCd && t[targetCdNm] === cd && t.tekiyoStartYmdString <= date && t.tekiyoEndYmdString >= date
      if (t.tekiyoStartYmdDisp !== undefined) return t.kaishaCd === kaishaCd && t[targetCdNm] === cd && t.tekiyoStartYmdDisp <= date && t.tekiyoEndYmdDisp >= date
      return undefined
    })
    return d
  },
  /**
   * 区分マスタから区分名称を取得
   * @param {*} list データリスト
   * @param {*} cd コード値
   * @param {*} kbnShuruiCd 区分種類コード
   * @returns
   * @example1 var d = indexeddb.getKubun('0010', this.kubunList, 'KBN001', '01')
   * @example2 var nm = indexeddb.getKubun('0010', this.kubunList, 'KBN001', '01').codeNm
   */
  getKubun: function (kaishaCd, list, kbnShuruiCd, cd) {
    var d = list.find((t) => {
      return t.kaishaCd === kaishaCd && t.kbnShuruiCd === kbnShuruiCd && t.code === cd
    })
    return d
  },
  /**
   * 種別マスタから種別名称を取得
   * @param {*} list データリスト
   * @param {*} cd コード値
   * @param {*} sbtShuriCd 区分種類コード
   * @returns
   * @example1 var d = indexeddb.getShubetsu('0010', 'this.shubetsuList, 'SBT001', '01')
   * @example2 var nm = indexeddb.getShubetsu('0010', this.shubetsuList, 'SBT001', '01').sbtNm
   */
  getShubetsu: function (kaishaCd, list, sbtShuruiCd, cd) {
    var d = list.find((t) => {
      return t.kaishaCd === kaishaCd && t.sbtShuruiCd === sbtShuruiCd && t.sbtCd === cd
    })
    return d
  },
  /**
   * システムコンフィグから設定情報を取得
   * @param {*} list データリスト
   * @param {*} cd コード値
   * @param {*} sbtShuriCd 区分種類コード
   * @returns
   * @example1 var d = indexeddb.getRecordByCd('0010', 'this.shubetsuList, 'SBT001', '01')
   * @example2 var nm = indexeddb.getRecordByCd('0010', this.shubetsuList, 'SBT001', '01').sbtNm
   */
  getSystemConfig: function (list, configName) {
    var d = list.find((t) => {
      return t.configName === configName
    })
    return d
  }
}
